import { IPaths } from "~/types/routing";

export const paths: IPaths = {
  index: "/product-description",
  generate: "/product-description/:productId"
};
